// You can write your custom Javascript here
$(document).ready(function($) {
   
  
/*Fetching country and state*/
    $.getJSON(window.themeAssets.countries, function(result){
        $.each(result, function(i, country){
         $("#CustomerFormCountry").append("<option value="+country.iso2+">"+country.name+"</option>")
        });
      });

      $('#CustomerFormCountry').change(function() {
       var selectedCountry=$("#CustomerFormCountry").val();
       $("#CustomerFormState").empty();
       $("#CustomerFormState").append("<option value=''>Select</option>");
       $.getJSON(window.themeAssets.states, function(result){
        $.each(result, function(i, state){
            if(state.country_code==selectedCountry)
            {
         $("#CustomerFormState").append("<option >"+state.name+"</option>")
            }
        });
      });
    });
    
    checkSugProd();

    
 setTimeout( function(){
      $( '.spr-form input[name="review[rating]"]' ).attr( 'id', 'review[rating]' );
      console.log('ran');
    }, 2500 );

  setTimeout( function(){
    $( '.footer__aside .subscribe__body input[name="email"]' ).attr( 'id', 'email' );
    $( '.footer__aside .subscribe__body input[name="email"]' ).before( '<label for="email" class="sr-only">Email</label>' );

    $( '.footer__aside .subscribe__body input[type="submit"]' ).attr( 'id', 'hidden-submit' );
    $( '.footer__aside .subscribe__body input[type="submit"]' ).before( '<label for="hidden-submit" class="sr-only">Submit</label>' );
  }, 1200 );

	
	setInterval( function(){
      var fullTotal = 0;
      $('.form-cart tbody tr .table__total span').each(function(){
        var qty = $(this).parent().parent().find('.qty__field').val();
        var priceStr = $(this).parent().parent().find('.table__price .money').text();
        console.log(priceStr);
        var priceInt = priceStr.substring(1);
        priceInt = priceInt / 1;
        var total = qty * priceInt;
        fullTotal += total;
        $(this).text('$'+total.toFixed(2));
      });
      
      $('.subnew span').text('$'+fullTotal.toFixed(2));
      
      if ($('#wholesaleActive').length != 0){
        
        $('.widget__container').find('.cart-item').each(function(){
          var targetRow = $(this).find('.cart-item__row').last();
          var quant = targetRow.find('span').first().text();
          var price = targetRow.find('span').last().text().replace('$', '');
          if (price == '21.95'){
            price = '17.50'
          }
          else if(price == '13.99'){
            price = '10.80'
          }
          else if(price == '14.99'){
            price = '10.20'
          }
          else if(price == '16.99'){
            price = '11.25'
          }
          targetRow.find('span').last().text('$'+price);
          var fullPrice = price * quant;
          
          console.log(price);
        });

        $('.widget__container').find('.sug-prod__price').each(function(){
          var price = $(this).text().replace('$', '');
          if (price == '21.95'){
            price = '17.50'
          }
          else if(price == '13.99'){
            price = '10.80'
          }
          else if(price == '14.99'){
            price = '10.20'
          }
          else if(price == '16.99'){
            price = '11.25'
          }
          $(this).text('$'+price);
        });
      }
      
      var totalPrice = 0;
      $('.widget__container').find('.cart-item').each(function(){
        var targetRow = $(this).find('.cart-item__row').last();
        var quant = targetRow.find('span').first().text();
        var price = targetRow.find('span').last().text().replace('$', '');
        
        var fullPrice = price * quant;
        totalPrice += fullPrice
      });
      var totalPriceString = '$'+totalPrice.toFixed(2)
      
      if ($('.widget__container .wsaio--subtotal span').hasClass('money')){
        $('.widget__container .wsaio--subtotal span').removeClass('money');
        $('.widget__container .wsaio--subtotal span').removeClass('pre-money');
      }
      
      if ($('.widget__container .wsaio--subtotal span').text() != totalPriceString){
        $('.widget__container .wsaio--subtotal span').hide();
        if ($('.widget__container .wsaio--subtotal .loading').length <= 0){
        	$('.widget__container .wsaio--subtotal').append('<div class="loading">Calculating...</div>');
        }
      }
      else{
        $('.widget__container .wsaio--subtotal span').show();
        $('.widget__container .wsaio--subtotal .loading').remove();
      }
      
      $('.widget__container .wsaio--subtotal span').text(totalPriceString);
		
    }, 50 );
/*
$('[href="/cart"]').on('click', function(e){
  if ($('#wholesaleActive').length == 0){
    
  }
  else{
    e.preventDefault();
    window.location.href = "/cart";
  }
});
*/
  // Yotpo Rewards Footer Newsletter Signup
  $( '.footer' ).on( 'click', '.subscribe__body button', function( e ) {

    var customerEmail = $( '.subscribe__body input[type="email"]' ).val();

    var data = { 
      type: 'CustomAction',
      action_name: 'Newsletter Sign Up',
      customer_email: customerEmail
    };

    $.ajax({
      url: 'https://app.swellrewards.com/api/v2/actions',
      type: 'POST',
      data: JSON.stringify(data),
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      headers: { 
        'x-guid': 'qdooTb_IRmRqm2M8AJs9NA',
        'x-api-key': 'YxZW5pIC6x3Flk7aru0cTwtt'
      },
      // async: false,
      success: function(msg) {
          // alert(msg);
      }
    });
  });

   // Yotpo Rewards Modal Newsletter Signup
   $( 'body' ).on( 'click', 'div[role="dialog"] .klaviyo-form button', function( e ) {
    var customerEmail = $( 'div[role="dialog"] .klaviyo-form input[type="email"]' ).val();

    var data = { 
      type: 'CustomAction',
      action_name: 'Newsletter Sign Up',
      customer_email: customerEmail
    };

    $.ajax({
      url: 'https://app.swellrewards.com/api/v2/actions',
      type: 'POST',
      data: JSON.stringify(data),
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      headers: { 
        'x-guid': 'qdooTb_IRmRqm2M8AJs9NA',
        'x-api-key': 'YxZW5pIC6x3Flk7aru0cTwtt'
      },
      // async: false,
      success: function(msg) {
          // alert(msg);
      }
    });
  });

});

jQuery( window ).on( 'load', function() {
  checkSugProd();
} );

jQuery( '.js-cart-remove' ).on( 'click', function() {
  checkSugProd();
} ) 

function checkSugProd() {

  jQuery( '.sug-product' ).show();

  var cartItems = new Array();

  jQuery( '.cart-item__title a' ).each( function() {
    cartItems.push( jQuery( this ).text() );
  } );

  jQuery( '.sug-prod__title' ).each( function() {
    var prodText = jQuery( this ).text();
    if ( jQuery.inArray(prodText , cartItems ) !== -1 ) {
      jQuery( '.sug-product[data-title="'+prodText+'"]' ).hide();
      console.log( 'hit ' + prodText );
    }
  } );

  console.log( cartItems );

}
document.addEventListener('DOMContentLoaded', function() {
    var sliderSlides = document.querySelectorAll('.slider__slide');

    for (var i = 0; i < sliderSlides.length; i++) {
        var sliderWrapper = sliderSlides[i].querySelector('.slider__details-wrapper');
        
        if (sliderWrapper) {
            sliderSlides[i].classList.add('has-slider-wrapper');
        }
    }
});
// mega menu tabs
$(document).ready(function () {
    function activateTab($tab) {
        var tabId = $tab.data('tab');
        var $tabs = $tab.closest('[role="tablist"]').find('[role="tab"]');

        $tabs.removeClass('active').attr({
            'aria-selected': 'false',
            tabindex: '-1'
        });
        $('.tab-content').removeClass('active').attr('aria-hidden', 'true');

        $tab.addClass('active').attr({
            'aria-selected': 'true',
            tabindex: '0'
        });
        $('#' + tabId).addClass('active').attr('aria-hidden', 'false');
    }

    $('.tab-button').on('click', function () {
        activateTab($(this));
    });

    $('.tab-buttons[role="tablist"]').on('keydown', '[role="tab"]', function (e) {
        var $tabs = $(this).closest('[role="tablist"]').find('[role="tab"]');
        var index = $tabs.index(this);
        var nextIndex = index;

        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            nextIndex = (index + 1) % $tabs.length;
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            nextIndex = (index - 1 + $tabs.length) % $tabs.length;
        } else if (e.key === 'Home') {
            nextIndex = 0;
        } else if (e.key === 'End') {
            nextIndex = $tabs.length - 1;
        } else {
            return;
        }

        e.preventDefault();
        activateTab($tabs.eq(nextIndex));
        $tabs.eq(nextIndex).focus();
    });
});
// Remove message_notice if blank
$(document).ready(function() {
  var messageNotice = $('.message_notice');
  
  if (messageNotice.text().trim() === '') {
    messageNotice.css('display', 'none');
  }
});
// Yummy Details Accordion
$(document).ready(function() {
    // Function to handle accordion toggle
    function toggleAccordion() {
        var $trigger = $(this);
        var accordionContent = $trigger.next('.accordion-content').length
          ? $trigger.next('.accordion-content')
          : $trigger.closest('h3').next('.accordion-content');
        var isExpanded = !$trigger.hasClass('active');

        accordionContent.slideToggle();
        $trigger.toggleClass('active').attr('aria-expanded', isExpanded ? 'true' : 'false');
    }

    // Attach click event to the accordion triggers
    $('.accordion-trigger').on('click', toggleAccordion);

    // Adjust behavior based on screen size
    function adjustAccordion() {
        if ($(window).width() < 767) {
            $('.accordion-content').hide();
            $('.accordion-trigger').removeClass('active').attr('aria-expanded', 'false');
            $('.accordion-icon').removeClass('active-icon').addClass('inactive-icon');
        } else {
            $('.accordion-content').show();
            $('.accordion-trigger').addClass('active').attr('aria-expanded', 'true');
            $('.accordion-icon').removeClass('inactive-icon').addClass('active-icon');
        }
    }

    // Call the adjustAccordion function on page load and window resize
    adjustAccordion();
    $(window).on('resize', adjustAccordion);
});

/* Accessibility enhancements (WCAG 2.1/2.2 AA) */
$(document).ready(function () {
  function syncToggleAria($trigger) {
    var targetSelector = $trigger.attr('data-js-target') || $trigger.attr('data-target');
    if (!targetSelector) return;

    var className = $trigger.attr('data-js-class') || $trigger.attr('data-class') || 'is-expanded';
    var isExpanded = false;

    if (targetSelector === '#header') {
      isExpanded = $('#header').hasClass(className);
    } else if (targetSelector === '#widget-cart') {
      isExpanded = $('#widget-cart').hasClass(className);
    } else {
      isExpanded = $(targetSelector).hasClass(className);
    }

    $trigger.attr('aria-expanded', isExpanded ? 'true' : 'false');

    if (targetSelector === '#widget-cart') {
      $('#widget-cart').attr({
        'aria-hidden': isExpanded ? 'false' : 'true',
        'aria-modal': isExpanded ? 'true' : 'false'
      });
    }

    if ($trigger.hasClass('btn-burger')) {
      $trigger.attr('aria-label', isExpanded ? 'Close menu' : 'Open menu');
    }

    if ($trigger.hasClass('nav-utilities__search-btn')) {
      $trigger.attr('aria-label', isExpanded ? 'Close search' : 'Search');
    }
  }

  function syncAllToggleAria() {
    $('.js-btn-toggle[data-js-target], .js-btn-toggle[data-target]').each(function () {
      syncToggleAria($(this));
    });
  }

  $(document).on('click', '.js-btn-toggle', function () {
    setTimeout(syncAllToggleAria, 0);
  });

  $(document).on('click', function () {
    setTimeout(syncAllToggleAria, 0);
  });

  function initAccordionA11y() {
    $('.js-accordion .js-accordion-head').each(function (index) {
      var $head = $(this);
      var $body = $head.next('.accordion__body');
      var panelId = $body.attr('id') || ('accordion-panel-' + index);
      var headId = $head.attr('id') || ('accordion-head-' + index);

      $head.attr({
        id: headId,
        role: 'button',
        tabindex: '0',
        'aria-controls': panelId,
        'aria-expanded': $head.closest('.accordion__section').hasClass('is-expanded') ? 'true' : 'false'
      });
      $body.attr({
        id: panelId,
        role: 'region',
        'aria-labelledby': headId
      });
    });
  }

  initAccordionA11y();

  $(document).on('click', '.js-accordion .js-accordion-head', function () {
    var $head = $(this);
    setTimeout(function () {
      $head.closest('.js-accordion').find('.js-accordion-head').each(function () {
        var $sibling = $(this);
        $sibling.attr('aria-expanded', $sibling.closest('.accordion__section').hasClass('is-expanded') ? 'true' : 'false');
      });
    }, 0);
  });

  $(document).on('keydown', '.js-accordion .js-accordion-head', function (e) {
    if (this.tagName === 'BUTTON') return;
    if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
      e.preventDefault();
      $(this).trigger('click');
    }
  });

  $(document).on('click', '.js-product-options [role="radio"]', function () {
    var $radio = $(this);
    var $group = $radio.closest('[role="radiogroup"]');
    $group.find('[role="radio"]').attr({
      'aria-checked': 'false',
      tabindex: '-1'
    });
    $radio.attr({
      'aria-checked': 'true',
      tabindex: '0'
    });
  });

  $(document).on('keydown', '.js-product-options [role="radio"]', function (e) {
    var $radios = $(this).closest('[role="radiogroup"]').find('[role="radio"]');
    var index = $radios.index(this);
    var nextIndex = index;

    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      nextIndex = (index + 1) % $radios.length;
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      nextIndex = (index - 1 + $radios.length) % $radios.length;
    } else {
      return;
    }

    e.preventDefault();
    $radios.eq(nextIndex).trigger('click').focus();
  });

  function syncEntryAccordionAria($head) {
    var $body = $head.next('.js-entry-accordion-body');
    if (!$body.length) {
      $body = $head.closest('h6').next('.js-entry-accordion-body');
    }
    var isExpanded = $body.hasClass('is-expanded');
    $head.find('.js-entry-accordion-trigger').addBack('.js-entry-accordion-trigger').attr('aria-expanded', isExpanded ? 'true' : 'false');
  }

  $(document).on('click', '.js-entry-accordion h6, .js-entry-accordion-trigger', function () {
    var $head = $(this).closest('h6').length ? $(this).closest('h6') : $(this);
    setTimeout(function () {
      syncEntryAccordionAria($head);
    }, 400);
  });

  function enhanceTimelineControls() {
    $('.js-slider-timeline-dots .slick-slide').each(function () {
      var $slide = $(this);
      var label = $.trim($slide.find('.slider__dot strong').text());
      $slide.attr({
        role: 'button',
        tabindex: '0',
        'aria-pressed': $slide.hasClass('slick-current') ? 'true' : 'false',
        'aria-label': label ? ('Show ' + label) : 'Show timeline slide'
      });
    });
  }

  enhanceTimelineControls();
  setTimeout(enhanceTimelineControls, 500);
  $('.js-slider-timeline-dots').on('afterChange', enhanceTimelineControls);

  setTimeout(function () {
    $('.slick-dots button').each(function (index) {
      var $btn = $(this);
      if (!$btn.attr('aria-label')) {
        $btn.attr('aria-label', 'Go to slide ' + (index + 1));
      }
    });
  }, 500);

  var $widgetCart = $('#widget-cart');
  var lastCartTrigger = null;
  var cartWasExpanded = $widgetCart.hasClass('is-expanded');
  var qtyTimers = {};
  var latestQty = {};
  var ignoreQtyBlur = false;
  var savedCartFocus = null;

  function isElementDisplayed(el, root) {
    if (!el) return false;
    if (el.disabled || el.type === 'hidden') return false;
    if (el.tabIndex < 0) return false;
    if (el.getAttribute('aria-hidden') === 'true') return false;

    var node = el;
    while (node && node !== root && node.nodeType === 1) {
      var style = window.getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      node = node.parentElement;
    }

    return true;
  }

  function getCartFocusable() {
    var root = $widgetCart.find('.widget__container').get(0);
    if (!root) return [];

    var candidates = root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), iframe, [contenteditable], [tabindex]:not([tabindex="-1"])');
    var list = [];

    for (var i = 0; i < candidates.length; i++) {
      if (isElementDisplayed(candidates[i], root)) {
        list.push(candidates[i]);
      }
    }

    return list;
  }

  function focusElement(el) {
    if (!el || typeof el.focus !== 'function') return;
    try {
      el.focus({ preventScroll: true });
    } catch (err) {
      el.focus();
    }
  }

  var pinningDialogFocus = false;

  function cartCountMessage(count) {
    return 'Shopping cart, ' + count + (count === 1 ? ' item' : ' items');
  }

  function readCartCount() {
    var small = document.querySelector('.js-btn-cart small');
    if (!small) return null;
    var count = parseInt($.trim(small.textContent), 10);
    return isNaN(count) ? null : count;
  }

  function syncCartDialogName() {
    if (!$widgetCart.length) return;

    var title = $widgetCart.find('.form__title').get(0);
    if (!title) return;

    if (!title.id) title.id = 'widget-cart-title';

    var name = $.trim(title.textContent);
    if (!name) return;

    $widgetCart.attr('aria-labelledby', title.id);
    $widgetCart.removeAttr('aria-label');
  }

  function focusIsInCart() {
    if (!$widgetCart.length) return false;
    var active = document.activeElement;
    return !!active && (active === $widgetCart[0] || $widgetCart[0].contains(active));
  }

  function cartFocusTarget() {
    var title = $widgetCart.find('.js-cart-container .form__title').get(0);
    if (title) {
      if (!title.id) title.id = 'widget-cart-title';
      title.setAttribute('tabindex', '-1');
      return title;
    }

    var container = $widgetCart.find('.js-cart-container').get(0);
    var focusable = getCartFocusable();
    for (var i = 0; i < focusable.length; i++) {
      if (container && container.contains(focusable[i])) return focusable[i];
    }

    return $widgetCart.get(0);
  }

  function focusWidgetCart() {
    if (!$widgetCart.length || !$widgetCart.hasClass('is-expanded')) return false;

    var dialog = $widgetCart.get(0);
    var style = window.getComputedStyle(dialog);
    if (style.visibility === 'hidden' || style.display === 'none') return false;

    dialog.scrollTop = 0;
    $widgetCart.attr({
      'aria-hidden': 'false',
      'aria-modal': 'true'
    });
    syncCartDialogName();
    focusElement(cartFocusTarget());
    return focusIsInCart();
  }

  function scheduleCartFocus() {
    [0, 50, 150, 400].forEach(function (delay) {
      setTimeout(function () {
        if (!$widgetCart.hasClass('is-expanded') || focusIsInCart()) return;
        focusWidgetCart();
      }, delay);
    });
  }

  function handleCartExpandedChange() {
    if (!$widgetCart.length) return;

    var isExpanded = $widgetCart.hasClass('is-expanded');
    $widgetCart.attr({
      'aria-hidden': isExpanded ? 'false' : 'true',
      'aria-modal': isExpanded ? 'true' : 'false'
    });

    if (isExpanded && !cartWasExpanded) {
      var active = document.activeElement;
      if (active && active !== $widgetCart[0] && !$widgetCart[0].contains(active)) {
        lastCartTrigger = active;
      }
      savedCartFocus = null;
      pinningDialogFocus = true;
      scheduleCartFocus();
      setTimeout(function () {
        pinningDialogFocus = false;
      }, 450);
    } else if (!isExpanded && cartWasExpanded) {
      pinningDialogFocus = false;
      savedCartFocus = null;
      if (lastCartTrigger && document.contains(lastCartTrigger)) {
        focusElement(lastCartTrigger);
      }
      lastCartTrigger = null;
    }

    cartWasExpanded = isExpanded;
  }

  function getCartItemIndex($item) {
    return $item.parent().children('.cart-item').index($item);
  }

  function getFocusFingerprint(el) {
    if (!el || !$widgetCart.length || !$widgetCart[0].contains(el)) return null;

    var $el = $(el);
    var $item = $el.closest('.cart-item');
    if ($item.length) {
      var kind = 'title';
      if ($el.closest('.cart-item__image').length) kind = 'image';
      else if ($el.hasClass('js-cart-remove') || $el.hasClass('cart-item__remove')) kind = 'remove';
      else if ($el.hasClass('qty__btn--plus')) kind = 'plus';
      else if ($el.hasClass('qty__btn--minus')) kind = 'minus';
      else if ($el.hasClass('qty__field')) kind = 'input';
      else if ($el.closest('.cart-item__title').length) kind = 'title';
      return { area: 'item', index: getCartItemIndex($item), kind: kind };
    }

    if ($el.hasClass('btn--checkout') || $el.attr('name') === 'checkout') {
      return { area: 'checkout' };
    }
    if ($el.attr('href') === '/cart') {
      return { area: 'viewcart' };
    }

    var $sug = $el.closest('.sug-product');
    if ($sug.length) {
      var sugKind = 'link';
      if ($el.is('input[type="submit"], button[type="submit"]')) sugKind = 'submit';
      else if ($el.hasClass('prod_url')) sugKind = 'image';
      return {
        area: 'sug',
        index: $sug.parent().children('.sug-product:visible').index($sug),
        kind: sugKind
      };
    }

    return { area: 'index', index: getCartFocusable().indexOf(el) };
  }

  function focusWasLost() {
    var active = document.activeElement;
    return !active || active === document.body || active === document.documentElement;
  }

  function restoreSavedCartFocus() {
    if (pinningDialogFocus) return;
    if (!savedCartFocus || !$widgetCart.hasClass('is-expanded')) return;
    if (document.activeElement === $widgetCart[0]) return;
    if ($widgetCart[0].contains(document.activeElement)) return;
    if (!focusWasLost()) return;

    var target = null;

    if (savedCartFocus.area === 'item') {
      var $item = $widgetCart.find('.cart-item').eq(savedCartFocus.index);
      if (savedCartFocus.kind === 'plus') target = $item.find('.qty__btn--plus').get(0);
      else if (savedCartFocus.kind === 'minus') target = $item.find('.qty__btn--minus').get(0);
      else if (savedCartFocus.kind === 'input') target = $item.find('.qty__field').get(0);
      else if (savedCartFocus.kind === 'remove') target = $item.find('.js-cart-remove, .cart-item__remove').get(0);
      else if (savedCartFocus.kind === 'image') target = $item.find('.cart-item__image a').get(0);
      else target = $item.find('.cart-item__title a').get(0);
    } else if (savedCartFocus.area === 'checkout') {
      target = $widgetCart.find('[name="checkout"], .btn--checkout').get(0);
    } else if (savedCartFocus.area === 'viewcart') {
      target = $widgetCart.find('a[href="/cart"]').get(0);
    } else if (savedCartFocus.area === 'sug') {
      var $sug = $widgetCart.find('.sug-product:visible').eq(savedCartFocus.index);
      if (savedCartFocus.kind === 'submit') target = $sug.find('input[type="submit"], button[type="submit"]').get(0);
      else if (savedCartFocus.kind === 'image') target = $sug.find('.prod_url').get(0);
      else target = $sug.find('a').not('.prod_url').get(0);
    } else if (savedCartFocus.area === 'index' && savedCartFocus.index >= 0) {
      target = getCartFocusable()[savedCartFocus.index] || null;
    }

    if (target) focusElement(target);
  }

  function refreshWidgetCart(after) {
    $.ajax({
      url: '/cart',
      success: function (data) {
        var $data = $(data);
        var $totalElem = $data.find('.js-cart-global-total');
        $('.js-btn-cart strong').html($totalElem.html());
        $('.js-widget-cart .js-cart-container').html($data.find('.js-cart-container').html());
        if (typeof checkSugProd === 'function') {
          checkSugProd();
        }
        restoreSavedCartFocus();
        if (typeof after === 'function') {
          after();
        }
      }
    });
  }

  function scheduleWidgetQtyUpdate($item, qty) {
    if (typeof CartJS === 'undefined' || !$item.length) return;

    var itemIndex = getCartItemIndex($item);
    if (itemIndex < 0) return;

    latestQty[itemIndex] = qty;
    clearTimeout(qtyTimers[itemIndex]);
    qtyTimers[itemIndex] = setTimeout(function () {
      var nextQty = latestQty[itemIndex];
      if (typeof nextQty === 'undefined') return;

      CartJS.updateItem(itemIndex + 1, nextQty, {}, {
        success: function () {
          refreshWidgetCart();
        }
      });
    }, 300);
  }

  function handleWidgetQtyButton(btn) {
    var $btn = $(btn);
    var $item = $btn.closest('.cart-item');
    var $input = $btn.parent().find('.qty__field');
    var qty = parseInt($input.val(), 10);
    qty = $.isNumeric(qty) ? qty : 0;

    if ($btn.hasClass('qty__btn--plus')) {
      qty += 1;
    } else {
      qty = Math.max(0, qty - 1);
    }

    $input.val(qty);
    scheduleWidgetQtyUpdate($item, qty);
  }

  if ($widgetCart.length) {
    $('body').off('blur', '.widget__container .qty__field');
    $('body').off('click keypress', '.cart-item__content .qty__btn');
    if (window.jQuery && window.jQuery !== $) {
      window.jQuery('body').off('blur', '.widget__container .qty__field');
      window.jQuery('body').off('click keypress', '.cart-item__content .qty__btn');
    }

    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(handleCartExpandedChange).observe($widgetCart[0], {
        attributes: true,
        attributeFilter: ['class']
      });

      var cartContainer = $widgetCart.find('.js-cart-container').get(0);
      if (cartContainer) {
        new MutationObserver(function () {
          syncCartDialogName();
          if (!$widgetCart.hasClass('is-expanded')) return;
          if (pinningDialogFocus || document.activeElement === $widgetCart[0]) {
            focusWidgetCart();
            return;
          }
          requestAnimationFrame(restoreSavedCartFocus);
        }).observe(cartContainer, { childList: true });
      }
    }

    $widgetCart.on('focusin', function (e) {
      savedCartFocus = getFocusFingerprint(e.target);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' && e.keyCode !== 9) return;
      if (!$widgetCart.hasClass('is-expanded')) return;

      var dialog = $widgetCart[0];
      var focusable = getCartFocusable();
      var active = document.activeElement;
      var inside = active === dialog || dialog.contains(active);

      if (!focusable.length) {
        e.preventDefault();
        focusElement(cartFocusTarget());
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      var index = focusable.indexOf(active);

      if (!inside || index === -1) {
        e.preventDefault();
        focusElement(e.shiftKey ? last : first);
        return;
      }

      if (e.shiftKey && index === 0) {
        e.preventDefault();
        focusElement(last);
      } else if (!e.shiftKey && index === focusable.length - 1) {
        e.preventDefault();
        focusElement(first);
      }
    }, true);

    document.addEventListener('mousedown', function (e) {
      var btn = e.target.closest ? e.target.closest('#widget-cart .cart-item .qty__btn') : null;
      if (!btn) return;
      ignoreQtyBlur = true;
    }, true);

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('#widget-cart .cart-item .qty__btn') : null;
      if (!btn) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      handleWidgetQtyButton(btn);
      setTimeout(function () {
        ignoreQtyBlur = false;
      }, 0);
    }, true);

    document.addEventListener('focusout', function (e) {
      if (!e.target || !e.target.classList || !e.target.classList.contains('qty__field')) return;
      if (!e.target.closest || !e.target.closest('#widget-cart')) return;
      e.stopImmediatePropagation();
    }, true);

    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.classList || !e.target.classList.contains('qty__field')) return;
      if (!e.target.closest || !e.target.closest('#widget-cart')) return;
      if (ignoreQtyBlur) return;

      var $input = $(e.target);
      var qty = parseInt($input.val(), 10);
      if (!$.isNumeric(qty) || qty < 0) qty = 0;
      scheduleWidgetQtyUpdate($input.closest('.cart-item'), qty);
    }, true);
  }

  syncCartDialogName();

  var announcedCartCount = readCartCount();
  var cartCountLive = document.getElementById('cart-count-live');

  function syncCartCountAnnouncement(announce) {
    var count = readCartCount();
    if (count === null) return;

    var message = cartCountMessage(count);
    $('.js-btn-cart').attr('aria-label', message);

    if (!announce || count === announcedCartCount || !cartCountLive) {
      announcedCartCount = count;
      return;
    }

    announcedCartCount = count;
    cartCountLive.textContent = '';
    window.setTimeout(function () {
      cartCountLive.textContent = 'Cart updated, ' + message;
    }, 150);
  }

  syncCartCountAnnouncement(false);

  if (typeof MutationObserver !== 'undefined') {
    $('.js-btn-cart strong').each(function () {
      new MutationObserver(function () {
        syncCartCountAnnouncement(true);
      }).observe(this, { childList: true, subtree: true, characterData: true });
    });
  }

  var $cartPage = $('.js-cart-section-container');
  var savedCartPageFocus = null;

  function rememberCartPageFocus(el) {
    if (!$cartPage.length || !$cartPage[0].contains(el)) return;

    var $el = $(el);
    var $row = $el.closest('tbody tr');
    if ($row.length) {
      var kind = '';
      if ($el.hasClass('qty__btn--plus')) kind = 'plus';
      else if ($el.hasClass('qty__btn--minus')) kind = 'minus';
      else if ($el.hasClass('qty__field')) kind = 'input';
      else if ($el.hasClass('remove')) kind = 'remove';
      else if ($el.closest('.table__title').length) kind = 'title';
      else return;
      savedCartPageFocus = { index: $row.index(), kind: kind };
      return;
    }

    if ($el.is('[name="checkout"], .btn--checkout')) {
      savedCartPageFocus = { area: 'checkout' };
    }
  }

  function restoreCartPageFocus() {
    if (!savedCartPageFocus || !$cartPage.length || !focusWasLost()) return;

    var target = null;
    if (savedCartPageFocus.area === 'checkout') {
      target = $cartPage.find('[name="checkout"]').get(0);
    } else if (typeof savedCartPageFocus.index === 'number') {
      var $row = $cartPage.find('tbody tr').eq(savedCartPageFocus.index);
      if (savedCartPageFocus.kind === 'plus') target = $row.find('.qty__btn--plus').get(0);
      else if (savedCartPageFocus.kind === 'minus') target = $row.find('.qty__btn--minus').get(0);
      else if (savedCartPageFocus.kind === 'input') target = $row.find('.qty__field').get(0);
      else if (savedCartPageFocus.kind === 'remove') target = $row.find('a.remove').get(0);
      else if (savedCartPageFocus.kind === 'title') target = $row.find('.table__title a').get(0);
    }

    if (target) focusElement(target);
  }

  if ($cartPage.length) {
    $cartPage.on('focusin', function (e) {
      rememberCartPageFocus(e.target);
    });

    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(function () {
        requestAnimationFrame(restoreCartPageFocus);
      }).observe($cartPage[0], { childList: true });
    }
  }

  $(document).on('keydown', function (e) {
    if (e.key !== 'Escape' && e.keyCode !== 27) return;

    if ($('#widget-cart').hasClass('is-expanded')) {
      e.preventDefault();
      $('.js-btn-cart').first().trigger('click');
      return;
    }
    if ($('#header').hasClass('is-nav-expanded')) {
      $('.btn-burger').first().trigger('click');
    }
    if ($('#header').hasClass('is-search-expanded')) {
      $('.nav-utilities__search-btn').first().trigger('click');
    }
  });
});

